import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React, { useMemo } from 'react'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import deleteVmStyles from './deleteVmStyles'

const useStyles = makeStyles<Theme>((theme) => ({
  ...deleteVmStyles(theme),
}))

export default function SimpleResultsDeleteAll({
  virtualMachines,
  vmVolumes,
  vmPorts,
  allResourcesSuccess,
  vmDeletionResults,
  successfulVmDeletions,
  successfulVolumeDeletions,
  successfulPortDeletions,
}) {
  const classes = useStyles()

  return (
    <>
      <Text variant="subtitle2">
        <div className={clsx(classes.circleIcon, classes.greenCircle)}>
          <FontAwesomeIcon
            className={allResourcesSuccess ? classes.greenIcon : classes.redIcon}
            size="md"
          >
            {allResourcesSuccess ? 'check' : 'xmark'}
          </FontAwesomeIcon>
        </div>
        {allResourcesSuccess
          ? `${virtualMachines?.length + vmVolumes?.length + vmPorts?.length} resources deleted`
          : 'Some resources weren’t deleted due to an error'}
      </Text>
      <div className={classes.simpleResultsTable}>
        <Text variant="body2">Virtual Machines:</Text>
        <Text variant="caption1">
          {successfulVmDeletions?.length} of {vmDeletionResults?.length} deleted
        </Text>
        <Text variant="body2">Volumes:</Text>
        <Text variant="caption1">
          {successfulVolumeDeletions?.length} of {vmVolumes?.length} deleted
        </Text>
        <Text variant="body2">Ports:</Text>
        <Text variant="caption1">
          {successfulPortDeletions?.length} of {vmPorts?.length} deleted
        </Text>
      </div>
    </>
  )
}
